// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"672c4dd0","312":"538bd92e","453":"3847547b","627":"a12a2b83","905":"444ffa03","923":"8e4eabfd"}[chunkId] + ".chunk.js";
};